import { useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { newOfferValidationSchema } from "../user/validation/new-offer-validation";
import UploadImageComponent from "./upload-image-component";

export interface IProps {
  onClickForSaveBtn: () => void;
  openEdit: boolean;
  contentValue: string;
  dateValue: string;
}
function EditOfferPopup(props: IProps) {
  const { i18n, t } = useTranslation();
  const [type, setType] = useState<string>("text");
  type InitialValuesType = {
    offerContent: string;
    imageFile: string;
    date: string;
  };
  const initialValues: InitialValuesType = {
    offerContent: "",
    imageFile: "",
    date: "",
  };
  const { values, errors, touched, handleChange, handleSubmit, handleBlur } =
    useFormik({
      initialValues: initialValues,
      validateOnChange: true,
      validateOnBlur: true,
      validationSchema: newOfferValidationSchema,
      onSubmit: async () => {
        handleSubmit();
      },
    });

  return (
    <>
      {props.openEdit && (
        <div className="fixed top-0 z-50 left-0 inset-y-0 inset-x-0 mx-auto my-auto rounded-2xl bg-white shadow-[rgba(0,_0,_0,_0.10)_0px_0px_10px_0px] max-w-[505px] h-fit p-8 mobile:w-[calc(100vw-72px)]">
          <form
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="flex flex-col gap-6 place-items-center"
          >
            <div className="place-self-start text-xl font-arBold text-[#435363]">
              {t("schoolPostFormPopup.component.newOffer")}
            </div>
            <UploadImageComponent />
            <div className="flex flex-col gap-2">
              <label className="place-self-start px-0.5 text-zinc700 text-xl leading-[30px] font-arMedium">
                {t("schoolPostFormPopup.component.offerContent")}
              </label>
              <textarea
                defaultValue={props.contentValue + values.offerContent}
                id="offerContent"
                onChange={handleChange}
                onBlur={handleBlur}
                className={`${
                  touched.offerContent && errors.offerContent
                    ? "border-secondary-50 focus:border-secondary-50"
                    : "border-zinc400 focus:border-mint-500"
                } focus:border-mint-500 w-[425px] h-32 bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-136px)] mobile:h-32 px-4 py-[17px] rounded-[18px] border placeholder:text-neutral-500 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t(
                  "schoolPostFormPopup.component.offerContentPlaceholder"
                )}`}
              ></textarea>
              {touched.offerContent && errors.offerContent && (
                <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                  {errors.offerContent}
                </p>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
                {t("schoolPostFormPopup.component.offerPeriod")}
              </label>
              <input
                defaultValue={props.dateValue}
                id="date"
                name="date"
                onChange={(e) => handleChange(e)}
                onBlur={(e) => {
                  handleBlur(e);
                  setType("text");
                }}
                type={type}
                onFocus={() => setType("date")}
                className={`appearance-none w-[425px] h-[61px] bg-transparent mobile:max-w-[345px] mobile:w-[calc(100vw-136px)] mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border border-zinc400 placeholder:text-neutral-500 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                placeholder={`${t(
                  "schoolPostFormPopup.component.offerPeriodPlaceholder"
                )}`}
              ></input>
            </div>
            <button
              onClick={props.onClickForSaveBtn}
              disabled={errors.offerContent !== undefined ? true : false}
              type="submit"
              className={`${
                errors.offerContent !== undefined
                  ? "bg-mint-200"
                  : "bg-mint-500"
              } w-[425px] mobile:max-w-[345px] mobile:w-[calc(100vw-136px)] h-11 text-white text-xl font-arRegular rounded-2xl cursor-pointer`}
            >
              {t("app.shared.save")}
            </button>
          </form>
        </div>
      )}
    </>
  );
}

export default EditOfferPopup;
